export function blurApp() {
  const appLayoutEl = document.getElementsByClassName('gik-app-layout')[0];
  appLayoutEl?.classList.add('gik-blur');
}

export function unblurApp() {
  const appLayoutEl = document.getElementsByClassName('gik-app-layout')[0];
  appLayoutEl?.classList.remove('gik-blur');
}
